import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledGridRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: 'white',
  boxSizing: 'border-box',
  borderBottom: '1px solid ' + theme.palette.coolGrey[200],
}));

export const StyledGridCustomRow = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: 'white',

  borderTop: 'none',
  boxSizing: 'border-box',
});

export const StyledGridCell = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  ...theme.typography.paragraph,
}));

export const StyledGridHeaderCell = styled(Box)(({ theme }) => ({
  minHeight: 32,
  backgroundColor: theme.palette.grey[200],
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),

  display: 'flex',
  alignItems: 'center',

  textTransform: 'uppercase',
  '&': {
    ...theme.typography.paragraphHeaderBold,
  },
}));

export const StyledGridCustomCell = styled(Box)(({ theme }) => ({
  padding: 0,
  width: '100%',
  ...theme.typography.paragraph,
}));
